<template>
    <div class="xiangmu">
        <div class="leaderBox" v-if="showOrhide">
		<div class="newtext">新手指引</div>
			<img src="../../assets/images/maskClose.png" class="closeIt" @click="closeIt">
			<img src="../../assets/images/pop/step1.jpg" class="steps step1" v-if="status==1">
			<img src="../../assets/images/pop/step2.jpg" class="steps step2" v-if="status==2">
			<img src="../../assets/images/pop/step3.jpg" class="steps step3" v-if="status==3">
         <div class="stepbtn" @click="nextStep(status)">
				{{status==1?"下一步":status==2?"下一步":status==3?"我知道了":"我知道了"}}
			</div>
            <div class="bottomTip">
				<el-checkbox v-model="checked">下次不再提示</el-checkbox>
			</div>
		</div>
<!--        <div class="h-crumbOut">-->
<!--            <div class="h-crumbs">-->
<!--                <el-breadcrumb separator="|">-->
<!--                    <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>-->
<!--                    <el-breadcrumb-item>价格管理</el-breadcrumb-item>-->
<!--                </el-breadcrumb>-->
<!--            </div>-->
<!--        </div>-->
      <Breadtabsheader/>
        <div class="h-piece h-mrt30">
            <div class="h-formBox">
                <el-form :inline="true" :model="q" class="demo-form-inline h-formBorder">
					<div class="h-thirdColumn w-newColumn">
						<el-form-item label="产品型号">
						    <el-input v-model="q.materialDescrition" placeholder=""></el-input>
						</el-form-item>
						<el-form-item label="产品编号">
						    <el-input v-model="q.materialCode" placeholder=""></el-input>
						</el-form-item>
						<el-form-item label="产品大类">
						    <brselectlazy category="product_level" :v="q.hid" v-model="q.hid" :clearable="true"
								style="width:100%"/>
						</el-form-item>
						<el-form-item class="right-btn">
						    <el-button class="h-btn h-formBtn" @click="handleFilter">检索</el-button>
						    <el-button class="h-btn h-formBtn h-bgwhite" @click="chongzhi">重置</el-button>
						</el-form-item>
					</div>
                </el-form>
            </div>
        </div>
        <div class="h-table h-mrt30 Ju" v-if="clickActive==1">
            <el-table
                    ref="multipleTable"
                    @selection-change="handleSelectionChange"
                    :data="tableData2"
                    style="width: 100%"
					:border="true"
					max-height="440"
            >
                <el-table-column
                        type="selection"
                        width="40"
                        :label="all"
                >
                </el-table-column>
                <el-table-column
                        fixed
                        type="index"
                        label="#"
                        width="40">
                </el-table-column>
                <el-table-column
                        prop="levelname"
                        label="产品大类"
						min-width="150"
						:show-overflow-tooltip="true"
                >
                </el-table-column>

                <el-table-column
                        prop="materialCode"
                        label="产品编号"
						min-width="150"
                        :show-overflow-tooltip="true"
                >
                </el-table-column>
                <el-table-column
                        prop="materialDescrition"
                        label="产品型号"
						min-width="300"
						:show-overflow-tooltip="true"
                >
					<template slot-scope="scope">
						<div style="text-align: left;">
							{{scope.row.materialDescrition}}
						</div>
					</template>
                </el-table-column>
				<el-table-column
						prop="leltypecode"
						label="定价类型"
						min-width="150"
						:show-overflow-tooltip="true"
				>
				</el-table-column>
				<el-table-column
						prop="protype"
						label="型号属性"
						min-width="150"
						:show-overflow-tooltip="true"
				>
				</el-table-column>
				<el-table-column
						prop="type"
						label="级别/区域"
						min-width="150"
						:show-overflow-tooltip="true"
				>
					<template slot-scope="scope">
						<div v-if="scope.row.leltypecode=='内销'">
							{{scope.row.type | dictname('customer_group')}}
						</div>
						<div v-if="scope.row.leltypecode=='外销'">
							{{scope.row.type | dictname('dj_foreign_area')}}
						</div>
					</template>
				</el-table-column>
				<el-table-column
						prop="value"
						label="价格"
						min-width="150"
						:show-overflow-tooltip="true"
				>
				</el-table-column>
				<el-table-column
						prop="currency"
						label="币种"
						min-width="150"
						:show-overflow-tooltip="true"
				>
					<template slot-scope="scope">
						<div >
							{{scope.row.currency | dictname('YLCurrency')}}
						</div>
					</template>
				</el-table-column>


                <el-table-column
                        prop="setprice"
                        label="定价状态"
						min-width="150"
						:show-overflow-tooltip="true"
                >
                </el-table-column>
                <el-table-column
                        prop="cdates"
                        label="最近一次申请定价时间"
						width="200"
						:show-overflow-tooltip="true"
                >
                </el-table-column>
                <el-table-column
                        label="操作"
                        width="160"
                        fixed="right"
                    >
                    <template slot-scope="scope">
                       <div style="text-align: left;">
						   <el-button
						            v-if="scope.row.setpriceastatus==1||scope.row.setpriceastatus==3"
						            type="text"
						            size="small"
						            class="h-tableLink h-btn" @click="todetail(scope.row)">
						        查看
						    </el-button>
						    <el-button
						   								v-if="scope.row.setpriceastatus==2"
						            type="text"
						            size="small"
						            class="h-tableLink h-btn" @click="dingjiaxiugai(scope.row)">
						        修改
						    </el-button>

						    <el-button
						            type="text"
						            size="small"
						            class="h-tableLink h-btn"
									@click="faqidingjia(scope.row)">
						        发起定价
						    </el-button>
					   </div>
						<!-- <div class="l-operationBox">
							<span class="l-operationlist br-operation-look" v-if="scope.row.setpriceastatus==1||scope.row.setpriceastatus==3" title="查看" @click="todetail(scope.row)"></span>
							<span class="l-operationlist br-operation-xg" v-if="scope.row.setpriceastatus==2" title="修改" @click="dingjiaxiugai(scope.row)"></span>
							<span class="l-operationlist br-operation-fqdj" v-if="scope.row.setpriceastatus!=2" title="发起定价" @click="faqidingjia(scope.row)"></span>
						</div> -->
                    </template>
                </el-table-column>
            </el-table>
            <div class="h-tableB h-mrt30">
                <div class="h-tableBL">
                    <el-button class="h-btn h-formBtn h-bgblueQ" icon="h-el-icon h-el-icon-import"
                               style="margin-left:-20px;" @click="outexcel">批量导出
                    </el-button>
                    <!--                        <el-button class="h-btn h-formBtn h-bgblueQ" icon="h-el-icon h-el-icon-import">批量导入</el-button>-->
                    <el-button
                            class="h-btn h-formBtn h-bgblueQ"
                            icon="h-el-icon h-el-icon-export"
                            @click="uploaddownexcelflagbtn">
                        批量导入
                    </el-button>
                    <uploaddownexcel
                            :visible.sync="uploaddownexcelflag"
                            v-if="uploaddownexcelflag"
                            clsname="priceImportExcel"
                            :startrow="3"
                            @callback="uploadExcelFilecallback"/>
                </div>

                <div class="h-pagination2">
                    <pagination :page="q" @query="query"/>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import ss from '../../api/SystemService'
    import uploaddownexcel from '../../components/uploaddown/uploaddownexcel'

    export default {
        components: {
            uploaddownexcel,
        },
        name: "productManage",
        data() {
            return {
                //批量导入
                uploaddownexcelflag: false,
                showOrhide:false,
				status:1,
				checked:true,
				toshow:"priceManage",

                dingjiazhuangtai: [
                 {
                    value: 1,
                    label: '已定价'
                }, {
                    value: 0,
                    label: '未定价'
                }, {
					value: 2,
					label: '暂存'
				}, {
					value: 3,
					label: '提交审核中'
				}],


                wuliaozu: [],

                chanpindalei: [],

                suoyoudingjia: {},

                dingjiashijian: {},


                q: {

                    hid: null,
                    setprice: null,
                    materialGroupCode: null,
                    materialDescrition: null,
                    materialCode:null,

                    pageSize: 10,
                    pageNo: 1,
                    total: 0,

                },


                //表单
                all: '全部',
                formInline: {
                    dalei: '',
                    status: '',
                    group: '',
                    type: '',
                },
                //表格
                multipleSelection: [],
                tableData2: [],
                clickActive: 1
            }
        },

        //加载页面默认执行
        created() {
            //默认首次交互
            this.gettableels();
			this.showzhezhao()
        },
        beforeRouteLeave(to, from, next) {
            from.meta.keepAlive = false;
            next();
        },
        activated(){
            this.query();
        },
        //监听
        watch: {},


        methods: {
//导入Excel
            uploaddownexcelflagbtn() {
                this.uploaddownexcelflag = true;
            },
            uploadExcelFilecallback(rd) {
                this.query();
                this.$msg.msgs(rd.msg);
            },

            handleCurrentChange() {

            },
            handleSizeChange() {

            },


            //重置
            chongzhi(){

                this.q.hid = '';

                this.q.setprice = '';

                this.q.materialGroupCode = '';

                this.q.materialDescrition = '';

                this.q.materialCode = '';

            },


            //查询翻页
            query() {

                this.q.idas = [];
                console.log(this.q, '看看都有啥')

                ss.chanpin.havmarselect3QPage(this.q).then(rd => {

                    this.tableData2 = [],

                        this.q.total = rd.total;

                    console.log(rd.records,'看看多少')

                    for (var t in rd.records) {

                        console.log(rd.records[t]);


                        var ss = {

                            levelname: rd.records[t].levelname==null?"空":rd.records[t].levelname,//产品大类
                            groupname: rd.records[t].groupname==null?"空":rd.records[t].groupname,//物料组名
                            materialGroupCode: rd.records[t].materialGroupCode,//物料组
                            materialDescrition: rd.records[t].materialDescrition,//物料型号
                            oemType: rd.records[t].oemType,//业务类型  SH或者HK。SH为上海OEM，HK为香港OEM    ****只有从我们这里保存的产品才有****
                            hid: rd.records[t].hid,
                            rowId: rd.records[t].rowId,
                            materialCode: rd.records[t].materialCode,//含虚拟物料的表的编码
                            rowId: rd.records[t].rowId,//mdm取数的表的主键
                            setprice: rd.records[t].setprice==null?'mdm物料':rd.records[t].setprice == 0 ? '未定价' :rd.records[t].setprice == 1 ? '已定价':rd.records[t].setprice == 2 ?'暂存':rd.records[t].setprice == 3 ?'提交审核中':'',
                            cdate: rd.records[t].cdate,//虚拟物料创建时间
                            materialCode: rd.records[t].materialCode,//产品编号id
							setpriceastatus: rd.records[t].setprice==null?1:rd.records[t].setprice,
                            cdates: rd.records[t].zuihoudingjia == null || rd.records[t].zuihoudingjia == '' ? '' : this.$util.riQi(rd.records[t].zuihoudingjia),//最后定价时间
                            typeUserCode: rd.records[t].typeUserCode,
                            protype: rd.records[t].protype,
							leltypecode: rd.records[t].leltypecode=='0'?"外销":"内销",
							type: rd.records[t].type,
							value: rd.records[t].value,
							currency: rd.records[t].currency,
							serviceProductsType: rd.records[t].serviceProductsType,
							gross: rd.records[t].gross,
							cost: rd.records[t].cost,
							unitPrice: rd.records[t].unitPrice,
							unitSellingPrice: rd.records[t].unitSellingPrice,
							xiaoe: rd.records[t].xiaoe,//是否计入销额
							jishu: rd.records[t].jishu,//是否计入基数
							factory: rd.records[t].factory,//工厂
							marketType: rd.records[t].marketType,//市场分类
							sceneCode: rd.records[t].sceneCode, //场景分类编码
							sceneName: rd.records[t].sceneName,//场景分类名称
							productClass: rd.records[t].productClass,//成品类别
                        }
                        this.tableData2.push(ss);

                    }


                })
            },


            //加载配置项
            gettableels() {

                this.query();

            },


            handleFilter() {
                this.q.pageNo = 1;
                this.query();
            },


            handleSelectionChange(val) {

                console.log(val)
                this.multipleSelection = val;
            },


            //导表
            outexcel() {
                if(this.multipleSelection.length>0){
                    var model = [];
                    for (var d in this.multipleSelection) {
                        model.push(
                            {
                                materialid:this.multipleSelection[d].materialCode
                            }
                        )
                    }
                    ss.chanpin.downloadExcelbymodel3Q(model);
                }else{
                    ss.chanpin.downloadExcelbyq3Q(this.q);
                }
            },

			//修改定价
            dingjiaxiugai(q) {
                if(q.materialCode){
				    this.$router.push({path: '/chanp/priceChange',query:q});
                }else{
                    this.$msg.msge('数据错误，缺少必要的物料号')
                }
            },
			//发起定价
            faqidingjia(q) {
				if(q.materialCode){
					this.$router.push({path: '/chanp/priceChange',query:q});
				}else{
					this.$msg.msge('数据错误，缺少必要的物料号')
				}
            },
			//查看详情
			todetail(q) {
                if(q.materialCode){
                    this.$router.push({path: '/chanp/priceOnlyRead',query:q});
                }else{
                    this.$msg.msge('数据错误，缺少必要的物料号')
                }
            },
            closeIt(){
				this.showOrhide = false;
				if(this.checked){
					ss.salesList.toshow(this.toshow,this.checked).then(rd => {
						console.log(rd)
						this.showOrhide = false;
					})
				}else{
					ss.salesList.toshow(this.toshow,this.checked).then(rd => {
						console.log(rd)
						this.showOrhide = false;
					})
				}
            },
            nextStep(i){
				if(this.status ==1){
					this.status = 2;
                }else if(this.status ==2){
					this.status = 3;
				}else if(this.status ==3){
					if(this.checked){
						ss.salesList.toshow(this.toshow,this.checked).then(rd => {
							console.log(rd)
							this.showOrhide = false;
						})
					}else{
						ss.salesList.toshow(this.toshow,this.checked).then(rd => {
							console.log(rd)
							this.showOrhide = false;
						})
					}
				}
			},
			showzhezhao(){
				ss.salesList.toshow(this.toshow).then(rd => {
					console.log(rd)
				    if(rd == false){
				        this.showOrhide = false;
				    }else{
				        this.showOrhide = true;
				    }
				})
			}
        },

        mounted() {
			// this.status = sessionStorage.priceManage?sessionStorage.priceManage:1;
			// if(sessionStorage.priceManage != 2){
			// 	this.showOrhide = true;
			// }
        },
    }
</script>
<style scoped>
    .xiangmu > .h-piece, .h-mrt30 {
        margin: 20px;
    }

    .h-formBtnOut .h-mr20 {
        margin-left: 3rem !important;
    }
</style>
<style>
.Ju .h-btn.el-button.h-tableLink{
    padding: 0 0.05rem;
}

</style>
<style scoped lang="scss">
    .bottomTip{
		position: absolute;
		left: 49.7%;
		bottom: 0.3rem;
		transform: translateX(-50%);
		z-index: 999999;
	}
	.newtext{
		font-size: 0.28rem;
		color: white;
		position: absolute;
		top:0.2rem;
		left: 50%;
		transform: translateX(-50%);
		font-weight: bold;
		text-shadow:1px 1px 4px #2785E7;
		z-index: 2;
	}
    .leaderBox{
		width: 100%;
		height: 100%;
		background-color: rgba(0,0,0,0.4);
		position: fixed;
		z-index: 99999;
		overflow: hidden;
		top: 0;
		left: 0;
		.leaderbg{
			width: 100%;
			height: 100%;
		}
		.steps{
			position: absolute;
			z-index: 1;
		}
		.step1{
			top:0;
			left:0;
		}
		.step2{
			top:0;
			left:0;
		}
		.step3{
			top:0;
			left:0;
		}
		.stepbtn{
			width: 1.9rem;
			height: 0.6rem;
			border: 0.03rem solid #FFFFFF;
			background-color: rgba(0,0,0,0.1);
			border-radius: 5px;
			display: flex;
			justify-content: center;
			line-height: 0.5rem;
			position: absolute;
			z-index: 99;
			bottom: 0.65rem;
			left: 50%;
			transform: translateX(-50%);
			font-size: 0.27rem;
			letter-spacing: 2px;
			color: white;
			cursor: pointer;
		}
		.closeIt{
			width: 0.3rem;
			height: 0.3rem;
			position: absolute;
			top: 0.2rem;
			right: 0.2rem;
			cursor: pointer;
			z-index: 2;
		}
	}
</style>


